import * as React from 'react';
import { Icon } from '@teamsnap/teamsnap-ui';

export interface Props {
  suggestions: any[];
  isLoading: boolean;
  isLoadingError: boolean;
  cursorIndex: number;
  onSelectFunction: (selectedItem) => any;
}

const noResultsResponse = () => (
  <div className="u-spaceEndsSm u-spaceSidesMd">
    <p className="u-spaceBottomNone">We're sorry, but there are no results matching your query.</p>
  </div>
);

const loadingErrorResponse = () => (
  <div className="u-spaceEndsSm u-spaceSidesMd">
    <p className="u-spaceBottomNone">We're sorry, but something went wrong searching for results.</p>
  </div>
);

const loadingDataResponse = () => (
  <div className="u-spaceMd u-textCenter">
    <span className="PulseAnimation">
      <span className="PulseAnimation-dot"></span>
      <span className="PulseAnimation-dot"></span>
      <span className="PulseAnimation-dot"></span>
    </span>
  </div>
);

const mainSuggestionContent = (
  index: number,
  suggestion: any,
  selected: boolean,
  selectedItemRef: any,
  clickFunction: (selectedItem) => any
) => (
  // Keyboard control provided by parent - navigation search
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
  <div
    key={index}
    className={`u-flex ac-suggestion ac-selectable ${selected ? 'ac-cursor' : ''}`}
    ref={selected ? selectedItemRef : null}
    onClick={() => clickFunction(suggestion)}
  >
    <Icon name={suggestion.defaultIcon} mods="u-spaceRightSm u-colorGrey" style={{ height: 26, width: 26 }} />
    <span className="u-inlineBlock" style={{ maxWidth: 'calc(100% - 30px)' }}>
      <p className="u-textBold">{suggestion.text}</p>
      <p className="ac-subtext">{suggestion.subtext}</p>
    </span>
  </div>
);

const NavigationSearchSuggestions: React.FC<Props> = ({
  suggestions,
  isLoading,
  isLoadingError,
  cursorIndex,
  onSelectFunction,
}: Props) => {
  const selectedItemRef = React.useRef(null);

  React.useEffect(() => {
    if (cursorIndex > -1 && selectedItemRef.current?.scrollIntoView) {
      selectedItemRef.current?.scrollIntoView(false)
    }
  }, [cursorIndex]);

  const renderSuggestions = () => {
    if (isLoading) {
      return loadingDataResponse();
    } else if (isLoadingError) {
      return loadingErrorResponse();
    } else if (!suggestions || suggestions.length === 0) {
      return noResultsResponse();
    } else {
      return (
        <>
          {suggestions.map((searchItem, index) =>
            mainSuggestionContent(index, searchItem, cursorIndex === index, selectedItemRef, onSelectFunction)
          )}
        </>
      );
    }
  };

  return (
    <div className="Panel u-sizeFull u-spaceTopXs ac-panel">
      <div className="ac-dataset ac-dataset-navSearch">{renderSuggestions()}</div>
    </div>
  );
};

export default NavigationSearchSuggestions;
